import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box, LinearProgress } from '@mui/material'
import { BaseFeedbackConIcona, ICONE, BaseGridLayout, BaseButtons, formattaImportoMonetario, formattaData, oggiOraAttuale } from '@lucan/base-ui'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import ConfigManager from 'components/config/ConfigManager'
import { useVerbaliContext } from 'context/VerbaliProvider'
import useNavigate from 'utils/useNavigate'
import FrontofficeContenitore from '../FrontofficeContenitore'
import Verbale from './Verbale'
import Titolone from 'components/ui/Titolone'
import ScatolettaDownloadAllegato from 'components/ui/ScatolettaDownloadAllegato'
import BreadcrumbsFrontOffice from 'components/ui/frontoffice/BreadcrumbsFrontOffice'
import ValutaServizioRender from 'components/valutaServizio/ValutaServizioRender'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'
import { FRONTOFFICE_VERBALE_RITORNO_PAGAMENTO } from 'configuration/frontoffice'

const CFG = FRONTOFFICE_VERBALE_RITORNO_PAGAMENTO

export default function RitornoPagamento() {
  const { navigate } = useNavigate()

  const { parametriEsitoPagamento } = useParams()

  const { chiaveVerbalePagamento, salvaVerbale, verbale } = useVerbaliContext()

  const [messaggio, setMessaggio] = useState(null)


  const [dataReturn, setdataReturn] = useState(null)

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  useEffect(() => {
    async function chiamataRitornoPagamento() {
      const { ok, data } = await inviaOperazione(OPERAZIONI.PAGAMENTO_RITORNO, {
        chiave: chiaveVerbalePagamento,
        parametri: parametriEsitoPagamento
      }, {})

      if (ok) {
        const { esito, ...restData } = data
        if (esito) {
          if(restData.pagamento.stato === 'pagato'){
            setdataReturn(restData)
            salvaVerbale(restData.verbale)
            return
          }
          
        } else {
          setMessaggio(messaggio)
          
        }
      }
      setdataReturn(false)
    }
    chiamataRitornoPagamento()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chiaveVerbalePagamento, parametriEsitoPagamento])

  function tornaAlVerbale() {
    navigate(CHIAVI_ROUTES.FRONTOFFICE_VERBALE, {
      tab: dataReturn != false ? Verbale.CHIAVI_TABS.DATI_VERBALE : Verbale.CHIAVI_TABS.RIEPILOGO
    })
  }

  return (<>
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_FRONTOFFICE_VERBALE_RITORNO_PAGAMENTO]}
      render={({ txt, val }) =>
        <FrontofficeContenitore>
          <BreadcrumbsFrontOffice conf={val(CFG.BREADCRUMBS, {}, true)} />
          <br/>
          {inAttesaDelServer && <Box sx={{ my: 3 }}><LinearProgress /></Box>}

          {dataReturn !== null &&
            <>
              {dataReturn ? ( <Box>
                <BaseGridLayout alignCenter spacing={1}>
                  <ICONE.OK />
                  <Titolone>{txt(CFG.EFFETTUATO)}</Titolone>

                </BaseGridLayout>
                {verbale && 
                <Box>
                    <p>{txt(CFG.EFFETTUATO_FRASE)} <b>{verbale.numero_verbale}</b></p>
                    <br />
                    <p>{txt(CFG.IMPORTO)} <b>{formattaImportoMonetario(verbale.pagamenti.find(p => p.codice_avviso === dataReturn.pagamento.codice_avviso).i)}</b></p>
                    <p>{txt(CFG.INVIATO)} <b>{formattaData(oggiOraAttuale())}</b></p>
                    <br />
                  
                    {dataReturn.idRicevuta &&
                      <>
                        <ScatolettaDownloadAllegato
                          sx={{maxWidth:'300px'}}
                          allegato={{id: dataReturn.idRicevuta, nome:val(CFG.RICEVUTA)}}
                          chiavePerUuid={chiaveVerbalePagamento}
                        />
                        <br /><br /><br />
                      </>
                    }
                  </Box>}
                </Box>
              ) : (<>
                <BaseGridLayout alignCenter spacing={1}>
                  <ICONE.ERRORE />
                  <Titolone>{txt(CFG.FALLITO)}</Titolone>
                </BaseGridLayout>
                <Box sx={{m:2}}><p>{txt(CFG.FALLITO_FRASE)}</p></Box>
                </>
              )}
            </>
          }
          
          {ScatolaMessaggi}

          {messaggio && <BaseFeedbackConIcona.Errore messaggio={messaggio} />}

          {!inAttesaDelServer &&
            <BaseButtons.MenoDettagli
              testo={val(CFG.TORNA_VERBALE)}
              onClick={tornaAlVerbale}
            />
          }
        </FrontofficeContenitore>
      }
    /><ValutaServizioRender />
    </>
  )
}


